module.exports = __webpack_public_path__ + "img/add-statuspage.dc034e9e.svg";